import { render, staticRenderFns } from "./MercadoManutencao.vue?vue&type=template&id=8c5b8a60&scoped=true"
import script from "./MercadoManutencao.vue?vue&type=script&lang=js"
export * from "./MercadoManutencao.vue?vue&type=script&lang=js"
import style0 from "./MercadoManutencao.vue?vue&type=style&index=0&id=8c5b8a60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5b8a60",
  null
  
)

export default component.exports